module.exports = __webpack_public_path__ + "img/icon-recommend-en.e26d63b2.png";